import React, { useState, useEffect } from 'react';

// Toast Component
export const Toast = ({ message, type, onClose }) => {
  const [closeAnimation, setCloseAnimation] = useState('fade-in');
    
  const handleDismiss = () => {
    setCloseAnimation('fade-out');
    setTimeout(() => {
      onClose();
    }, 300);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      handleDismiss();
    }, 3000);
    
    return () => clearTimeout(timer);
  }, [onClose]);

  const alertClass = type === 'success' ? 'alert-success' : 
                     type === 'error' ? 'alert-danger' : 
                     type === 'warning' ? 'alert-warning' : 'alert-info';

  return (
    <div className={`alert ${alertClass} ${closeAnimation} fade show d-flex align-items-center justify-content-between toast-content`} 
    role="alert"
    onClick={handleDismiss}>
     {/* style={{ cursor: 'pointer', pointerEvents: 'auto' }} */}
      <div>
        {type === 'success' && (
          <i className="fas fa-check-circle me-2"></i>
        )}
        {type === 'error' && (
          <i className="fas fa-exclamation-triangle me-2 text-danger"></i>
        )}
        {type === 'warning' && (
          <i className="fas fa-exclamation-triangle me-2"></i>
        )}
        {type === 'info' && (
          <i className="fas fa-info-circle me-2 text-info"></i>
        )}
        <span>{message}</span>
      </div>
    </div>
  );
};